import { ActionBase } from '../../../core/store/action/ActionBase';

export const LOCK_ACCOUNT = '[Customer] User Lock Account';

export class LockAccountAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = LOCK_ACCOUNT;

  constructor(public payload: { user: { key: string, identifier: string, reason?: string } }) {}
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/LockAccountAction.ts